import React, { useState, useEffect } from 'react';

import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';

import { ref, child, get, push, update, onValue } from 'firebase/database';

import { auth, db } from '../firebase';
/*
//import { loadObserver } from '../lib2/observer';
import { saveArticle } from './funcs/savearticle';
import { saveFaq, removeFaq,fetchFaqs } from './funcs/faq';
import {fetchUsers} from './funcs/users';
import { getSdgInfo,getSdgPhotos,getAllSdgPhotos } from './funcs/sdg';*/
import {
  getTop5Articles,
  getArticle,
  getTop15Articles,
  getTop21SdgArticles,
  getBottom3Articles,
} from './funcs/getarticles';
import { getSdgInfo, getSdgPhotos, getAllSdgPhotos } from './funcs/sdg';
import { fetchFaqs } from './funcs/getfaqs';

let ubl = '/';

if (window.location.hostname === 'localhost') {
} else {
  ubl = 'https://k4d-user-one.web.app/';
}

export const ApiProviderCtx = React.createContext();

export const useApiProviderCtx = () => React.useContext(ApiProviderCtx);
//const auth = getAuth();

export const ApiProvider = ({ children }) => {
  //get lang from locale
  const lang = 'en'; //i18n.language;

  const userbaselink = `${ubl}${lang}`;

  return (
    <ApiProviderCtx.Provider
      value={{
        userbaselink,
        lang,
        getTop5Articles,
        getTop15Articles,
        getSdgPhotos,
        getAllSdgPhotos,
        getArticle,
        getTop21SdgArticles,
        getBottom3Articles,
        fetchFaqs,
      }}
    >
      {children}
    </ApiProviderCtx.Provider>
  );
};
